import { render, staticRenderFns } from "./MyTasksPage.vue?vue&type=template&id=8a74dbb6&scoped=true"
import script from "./MyTasksPage.vue?vue&type=script&lang=js"
export * from "./MyTasksPage.vue?vue&type=script&lang=js"
import style0 from "./MyTasksPage.vue?vue&type=style&index=0&id=8a74dbb6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a74dbb6",
  null
  
)

export default component.exports